<template>
  <v-container fluid>
    <v-container fluid class="white  primary--text no-gutters">
      <v-content >
        <v-row>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="8">
            <h2 class="font-weight-bold">SASA<span class="red--text">PAY</span> DEVELOPERS</h2>
            <div class="mt-12">
              <typewriter
                  class="typewriter"
                  :replace="replace"
                  :type-interval="100"  
                  :replace-interval="1000"
              >
                <div>
                  <h1>SasaPay simplifies the process of collecting and disbursing money by providing a secure and easy-to-use solution.</h1>
                </div>
              </typewriter>
            </div>
            <div class="mt-12">
              <v-btn large class="error font-weight-bold rounded" href='https://docs.sasapay.app/docs/introduction/' target="blank">Explore Our APIs</v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <v-img src= "@/assets/sp/APIs.png"/>
          </v-col>
        </v-row>
      </v-content>
    </v-container>
    <v-content class="mt-0 ">
      <v-row>
        <v-col cols="12" md="2"></v-col>
        <v-col cols="12" md="8">
          <h1>The Tools you need</h1>
          <div class="mt-2">
            <p>Build world-leading services into your business, covering payments, data, fraud, identity, loyalty, consulting and more.</p>
          </div>
        </v-col>
      </v-row>
    </v-content>
    <v-content>
      <!--BEGIN -->
      <v-row>
        <v-col class="mx-auto" cols="12" md="8">
          <v-row>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-5">
                <v-card-title> <v-icon color="primary">mdi-account-reactivate</v-icon> <v-divider vertical class="ma-1 error"/>Customer To Business (C2B)</v-card-title>
                <v-card-text class="mt-2">
                  Customers can pay to the Business/Merchant through their SasaPay PayBills and Till Numbers.
                </v-card-text>
                <!-- <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" href="https://docs.sasapay.app/docs/customerTobusiness/ ">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions> -->
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-storefront</v-icon> <v-divider vertical class="ma-1 error"/>Business To Customer (B2C)</v-card-title>
                <v-card-text class="mt-2">
                  Business/Merchant can send money to Customers through SasaPay,MNOs,and Banks.
                </v-card-text>
                <!-- <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="https://docs.sasapay.app/docs/customerTobusiness">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions> -->
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-garage-variant</v-icon> <v-divider vertical class="ma-1 error"/>Business To Business (B2B)</v-card-title>
                <v-card-text class="mt-2">
                  Business/Merchant can send money to other SasaPay Businesses/Merchants Tills or PayBills.
                </v-card-text>
                <!-- <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions> -->
              </v-card>
            </v-col>
          </v-row>
          <!--BEGIN Row 3-->
          <v-row class="mt-5">
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-arrange-send-to-back</v-icon> <v-divider vertical class="ma-1 error"/>Person To Person (P2P)</v-card-title>
                <v-card-text class="mt-2">
                  Allows you to send money to almost anyone, anywhere using only their alias or a mobile number
                </v-card-text>
                <!-- <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions> -->
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-face-agent</v-icon> <v-divider vertical class="ma-1 error"/> AGENCY</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay Agent means a company or person authorized to offer cash deposit and redemption services by Sasapay to SASAPAY Subscribers.
                </v-card-text>
                <!-- <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions> -->
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-face-agent</v-icon> <v-divider vertical class="ma-1 error"/> Merchants</v-card-title>
                <v-card-text class="mt-2">
               Businesses can make Payment Collections from customers,send Payments to customers/users and make payments to other Businesses using SasaPay.

                </v-card-text>
                <!-- <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions> -->
              </v-card>
            </v-col>
            <!-- <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-nature-people</v-icon> <v-divider vertical class="ma-1 error"/> ESCROW</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay Escrow features protect our buyers and sellers by giving them a chance to verify the quality of goods and services before releasing payments.
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col> -->
            <!-- <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-trophy-award</v-icon> <v-divider vertical class="ma-1 error"/> Loyalty Programme</v-card-title>
                <v-card-text class="mt-2">
                  Streamline the way you acquire, engage and retain customers with secure and customizable loyalty and referral marketing programs.
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col> -->
          </v-row>
          <!--END row 3-->

          <!--BEGIN row 3-->
          <!-- <v-row class="mt-5">
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-fireplace</v-icon> <v-divider vertical class="ma-1 error"/> Marketplace</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay provides you with a platform where vendors can come together to sell their products or services to a curated customer base.
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col>
        
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-5">
                <v-card-title><v-icon color="primary">mdi-kabaddi</v-icon> <v-divider vertical class="ma-1 error"/> Jazia</v-card-title>
                <v-card-text class="mt-2">
                  SasaPay is a continuous overdraft service that allows our customers to complete their transactions even when they do not have enough funds in their SasaPay account.
                </v-card-text>
                <v-card-actions class="bottom-0 ml-2">
                  <RouterLink class="text-decoration-none" to="/">Learn More <v-icon color="error">mdi-arrow-right</v-icon></RouterLink>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row> -->
          <!--END Row 3-->
        </v-col>
      </v-row>
      <!--END -->
    </v-content>

    <v-content class="mt-5">
      <!--BEGIN -->
      <v-row>
        <v-col class="mx-auto" cols="12" md="8">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <h1 class="mt-3">Discover Your Way To Success</h1>
                <div class="mt-2 py-5 line-height-4">
                  <v-divider/>
                  <h3>
                    SasaPay empowers you to make collections and disburse money in a <br/> simple, secure, and seamless way. Whether you are in search of a comprehensive payment solutions or another choice of payment for your business, we have you covered.
                  </h3>
                </div>
                <div class="mt-5">
                  <v-btn class="rounded"
                         elevation="2"
                         color="primary"
                         outlined
                         @click="onSignUp"
                  >
                    Sign Up Now
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <v-img src= "@/assets/sp/api-01.png"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
          <!--END-->
        </v-col>
      </v-row>
      <!--END -->
    </v-content>
  </v-container>
</template>

<script>
import Typewriter from "typewriter-vue";
export default {
  name: "Solution",
  components: {
    Typewriter,
  },
  data: () => ({
    replace: [
      { from: "SasaPay simplifies the process of collecting and disbursing money by providing a secure and easy-to-use solution", to: "Whether you need a comprehensive payment solution for your business or are looking for an alternative payment method, we have you covered" },
    ],
  }),
  methods: {
    onSignUp(){
      window.open('https://merchants.sasapay.app/','_blank')
    }
  }
}
</script>